import { HomeScreen } from '@/features/home/HomeScreen';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/')({
  staticData: { nav: 'home' },
  component: HomeScreen,
});
